import { mapState } from "vuex";
export const equityCardIndexMixins = {
  computed: {
    equityCardTopBarList() {
      let topbarList = [
        {
          name: "权益卡管理",
          isActive: false,
          path: "/equityCard/manage",
          icon:require("@/assets/img/menuIcons/icon-equityCardmanage.png")
        },
        {
          name: "权益卡列表",
          isActive: false,
          path: "/equityCard/list",
          icon:require("@/assets/img/menuIcons/icon-equityCardlist.png")
        },
        {
          name: "核销记录",
          isActive: false,
          path: "/equityCard/writeOffRecord",
          icon:require("@/assets/img/menuIcons/icon-equityCardwriteOffRecord.png")
        },
      ];
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
      });
      return topbarList;
    },
  },
}
